import cn from "classnames"

import { Flex } from "@/atoms"

import styles from "./AdrTabTemplate.module.scss"

import { AdrTabTemplateProps } from "."

export const AdrTabTemplate = (props: AdrTabTemplateProps) => {
  const { children, classes = {} } = props

  return (
    <Flex justify="center" className={cn(styles.container, classes.container)}>
      <Flex vertical gap={32} className={cn(styles.content, classes.content)}>
        {children}
      </Flex>
    </Flex>
  )
}
